export class NotificationReadStateRepresentation {

  read: boolean;

  constructor(read: boolean) {
    this.read = read;
  }

}
